import React from 'react';
import {connect} from 'react-redux';
import { Select } from 'antd';
import 'antd/lib/select/style/index.css';
import {plainTranslate} from "../../../common/translate";
import SlideModal from '../../../common/SlideModal';
import SimpleForm from "../../Forms";
import { withRouter } from 'react-router-dom'
import client from '../../../../actions/client'

const { Option } = Select;

class LineUpdatedSelect extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            options: [],
            batchForm: false,
            value: '',
            clicked: null
        }
        this.handleClick = this.handleClick.bind(this);
        this.addItem = this.addItem.bind(this);
         this.onClickField = this.onClickField.bind(this);
    }
    
    componentDidMount() {
        if(this.props.data){
            this.setState({
             value: this.props.data
           })
         
       }
        this.setState({options : this.props.field.options});
    }
    
     onClickField(event){        
        this.setState({
          clicked: event.target.id
       }); 
    }
    
    handleClick(url = null, dependency=null, lineDependency=null) {
        let addVal = {};
        let jsonData = [];
        if(url && dependency && lineDependency){
        lineDependency.map(field => {
            
            let numb = (this.props.field.id).match(/^(\D*)(\d+)/)[2];
            if ('lines' in this.props.formData.form.initializeFromState2.values) {
                addVal[field] = this.props.formData.form.initializeFromState2.values.lines[numb][field];
            }
        })
        dependency.map(field => {
           
           addVal[field] = this.props.formData.form.initializeFromState2.values[field]; 
        })
        jsonData.push(JSON.stringify(addVal));

        let fields = this.props.field.selfUpdate.fields;
        client.post(url, addVal)
                .then(response => response.data)
                .then(response => {
                    fields.map(field => {
                        if (response[field]) {
                            let options = response[field];
                            options.push({'value': null, 'label': 'Without batch'});
                            this.setState({options: options});
                        }
                    })
                    if ('item' in response) {
                        this.setState({item: response['item']})
                    } else {
                        this.setState({item: false})
                    }
                })
            }        
    }
    
    handleChange(val, name, fieldProps) {
       // action(name, val);
         this.props.handleChangeLine(name, val)     
      
           this.setState({
                value: val
            })
        if ('changedFields' in fieldProps) {
            let addVal = {};
            let jsonData = [];
            fieldProps.changedFields.lineDependency.map(field => {
                let numb = (name).match(/^(\D*)(\d+)/)[2];
                addVal[field] = this.props.formData.form.initializeFromState2.values.lines[numb][field];
            })
            fieldProps.changedFields.dependency.map(field => {
                addVal[field] = this.props.formData.form.initializeFromState2.values[field];
            })
            addVal['body'] = val;

            jsonData.push(JSON.stringify(addVal));

            let fields = this.props.field.changedFields.fields;
            client.post(fieldProps.changedFields.url, addVal)
                    .then(response => response.data)
                    .then(response => {
                        fields.map(field => {
                            let ind = (name).indexOf('.'+this.props.field.id);
                            let line = (name).substring(0, ind);
                            this.props.handleChange(line + field, response[field]);
                        })
                    })
        }
    }
    
    addItem() {
        this.setState({batchForm: true});
    }

    render() {
    var url = null;    
    var dependency = null;
    var lineDependency = null;
    if(this.props.field.selfUpdate){
        url = this.props.field.selfUpdate.url;
        dependency = this.props.field.selfUpdate.dependency;
        lineDependency = this.props.field.selfUpdate.lineDependency;
    }
    let valueLabel = this.state.options.find(o => o.value === this.state.value);   
    if(this.state.clicked !== this.props.id){
        return <div 
        className={this.props.className + ' div-text-center'} 
        style={this.props.style} 
        onClick={this.onClickField}  
        id={this.props.id}>
        {valueLabel ? valueLabel.label : ''}</div> 
     }else{
        return (
                <div className={this.props.className+' '} style={this.props.style}>
                    <Select id={this.props.id}
                            style={{ height: 40, padding: 0, margin: 0, maxHeight: 45, overflow: 'hidden', width: '100%', border: 'none'}}
                            size={"small"}
                            value={this.state.value} 
                            notFoundContent = {plainTranslate(this.props.settings.locale, 'No options')}
                            onChange={(value) => this.handleChange(value, this.props.field.id, this.props.field)}
                            onMouseEnter={() => this.handleClick(url, dependency, lineDependency)} >                                
                                {this.state.options && this.state.options.map((option) =>
                                    <Option value={option.value} disabled = {option.disabled} key={Math.random().toString(36).substring(7)}>{option.label}</Option>
                                    )}
                                {this.props.field.id === 'batch' && <Option key={Math.random().toString(36).substring(7)} onClick={this.addItem}>+{plainTranslate(this.props.settings.locale, 'Add')}</Option>}
                    </Select>
                    {
                    this.state.batchForm &&
                    <SlideModal onClose={() => this.setState({batchForm: false})} title={plainTranslate(this.props.settings.locale, 'Batch')}>
                        <section className="newPanel">
                            <div className="panel-body">
                                <div className="row m-bot15">
                                    <SimpleForm
                                        saveRoute={this.props.match.params.db + '/api/batches'}
                                        formRoute={this.props.match.params.db + '/api/batches/'}
                                        match={{params: {id: null}}}
                                        matchAdditionalId={{params: {id: this.state.item}}}
                                        onSuccessfulSave={() => this.setState({batchForm: false})}
                                        isNew={true}
                                        popup={true}
                                        onCancel={() => this.setState({batchForm: false})}
                                        form={'initializeFromState'}
                                    />
                                </div>
                            </div>
                        </section>
                    </SlideModal>
                }
                </div>
                 )
     }
                }
            }

    const mapStateToProps = state => ({
        settings: state.settings,
        formData: state,
        });

    const mapDispatchToProps = dispatch => ({});

    export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LineUpdatedSelect));
